import { makeAutoObservable } from 'mobx'
import { CameraEventType, Cartesian3, CesiumTerrainProvider, Color, Ion, Math, NearFarScalar, PostProcessStageLibrary, SceneMode, ScreenSpaceEventType, Viewer, WebMapTileServiceImageryProvider } from '@cesiumgs/cesium-analytics'
import type * as Cesium from '@cesiumgs/cesium-analytics'
import { getPoiInfo } from '@/service/facility'

export class MapStore {
  viewer: Cesium.Viewer | null = null

  constructor() {
    makeAutoObservable(this)
  }

  initMap(container: string, isMapLoadedCallback: (viewer: any) => void) {
    Ion.defaultAccessToken = window.SystemConfig.defaultAccessToken
    this.viewer = new Viewer(container, {
      terrainProvider: new CesiumTerrainProvider({
        url: window.SystemConfig.mapConfig.dataConfig.koreaTerrain,
      }),
      imageryProvider: new WebMapTileServiceImageryProvider({
        url: window.SystemConfig.worldUrl,
        layer: '',
        style: '',
        tileMatrixSetID: '',
      }),
      // requestRenderMode: true,
      sceneMode: SceneMode.SCENE3D,
      // @ts-expect-error: add some text
      maximumScreenSpaceError: 64,
      animation: false,
      timeline: false,
      infoBox: false,
      vrButton: false,
      geocoder: false,
      navigationHelpButton: false,
      homeButton: false,
      useBrowserRecommendedResolution: false,
      baseLayerPicker: false,
      sceneModePicker: false,
      shouldAnimate: true,
      selectionIndicator: false,
      // creditContainer: 'credithide',
      fullscreenButton: false,
      shadows: false, // default: false
      targetFrameRate: 60,
      resolutionScale: 1,
      maximumRenderTimeChange: Number.POSITIVE_INFINITY,
      contextOptions: {
        // requestWebgl2: true,
        webgl: {
          // alpha: true,
          // depth: true,
          //  stencil: true,
          //  antialias: true,
          // premultipliedAlpha: true,
          preserveDrawingBuffer: true,
          // failIfMajorPerformanceCaveat: true,
        },
      },
    })
    this.viewer.clock.shouldAnimate = true
    const lensFlare = this.viewer.scene.postProcessStages.add(PostProcessStageLibrary.createLensFlareStage())
    lensFlare.enabled = false
    this.viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    this.viewer.scene.globe.depthTestAgainstTerrain = true // It cannot be modified as it will affect the slope analysis function
    this.viewer.scene.globe.translucency.frontFaceAlphaByDistance = new NearFarScalar(100.0, 0.1, 500.0, 1.0)
    this.viewer.scene.globe.undergroundColor = Color.SADDLEBROWN
    this.viewer.scene.screenSpaceCameraController.enableTranslate = true
    // viewer.scene.screenSpaceCameraController.enableCollisionDetection = false;
    this.viewer.scene.screenSpaceCameraController.enableTranslate = true
    this.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 0
    this.viewer.scene.screenSpaceCameraController.maximumZoomDistance = 10000000
    this.viewer.scene.globe.enableLighting = false
    // let layer = window.cviewer.imageryLayers.addImageryProvider(img);
    // window.cviewer.flyTo(layer)
    this.viewer.scene.screenSpaceCameraController.tiltEventTypes = [CameraEventType.RIGHT_DRAG, CameraEventType.PINCH]
    this.viewer.scene.screenSpaceCameraController.zoomEventTypes = [CameraEventType.WHEEL, CameraEventType.PINCH]
    this.viewer.scene.screenSpaceCameraController.rotateEventTypes = [CameraEventType.LEFT_DRAG, CameraEventType.PINCH]
    // @ts-expect-error: add some text
    this.viewer.cesiumWidget.creditContainer.style.display = 'none'
    this.viewer.camera.flyTo({
      destination: Cartesian3.fromDegrees(window.SystemConfig.mapConfig.Init.lng, window.SystemConfig.mapConfig.Init.lat, window.SystemConfig.mapConfig.Init.height),
      orientation: {
        heading: Math.toRadians(window.SystemConfig.mapConfig.Init.heading),
        pitch: Math.toRadians(window.SystemConfig.mapConfig.Init.pitch),
        roll: window.SystemConfig.mapConfig.Init.roll,
      },
      complete: () => {
        isMapLoadedCallback(this.viewer)
        window.cviewer = this.viewer
      },
    })
  }

  initCamera() {
    if (this.viewer !== null) {
      this.viewer.camera.flyTo({
        destination: Cartesian3.fromDegrees(window.SystemConfig.mapConfig.Init.lng, window.SystemConfig.mapConfig.Init.lat, window.SystemConfig.mapConfig.Init.height),
        orientation: {
          heading: Math.toRadians(window.SystemConfig.mapConfig.Init.heading),
          pitch: Math.toRadians(window.SystemConfig.mapConfig.Init.pitch),
          roll: window.SystemConfig.mapConfig.Init.roll,
        },
      })
    }
  }

  async queryPoiInfo(params: any) {
    return await getPoiInfo(params)
  }
}
